import moment from 'moment';
import zxcvbn from 'zxcvbn';
import _ from 'lodash';
import $ from "jquery";

class EmployeeCreateController {

  constructor($http, $rootScope, $state) {
    "ngInject";
    this.state = $state;
    this.$chargecodeInput = $('#chargecode-input');
    this.$rootScope = $rootScope;
    this.selectedChargeCodes = [];
    this.$http = $http;
    this.currentStep = 1;
    this.allUsers = [];
    this.roles = [];
    this.STEPS = {
      BASIC_INFO: 1,
      LEAVE: 2,
      CHARGE_CODES: 3,
      REVIEW_SUBMIT: 4
    };

    this.startDatePicker = $('#start-date-picker').datetimepicker({
      format: 'MM-DD-YYYY'
    });
    this.startDatePicker.on('dp.change', e => {
      this.user.startDate = e.date.format('YYYY-MM-DD');
      $rootScope.$digest();
    });


    this.effectiveDatePicker = $('#effective-date-picker').datetimepicker({
      format: 'MM-DD-YYYY'
    });
    this.effectiveDatePicker.on('dp.change', e => {
      this.user.userLeave[0].effectiveDate = e.date.format('YYYY-MM-DD');
      $rootScope.$digest();
    });

    this.user = {
      phoneNumbers: [],
      roles: [{
        roleName: 'USER',
        roleDescription: 'User',
        text: 'User'
      }],
      typeOfUser: 'employee',
      company: undefined,
      active: false,
      trackLeave: true,
      userName: undefined,
      employmentStatus: undefined,
      firstName: undefined,
      addresses: [],
      lastName: undefined,
      lastSignedIn: undefined,
      lateEntryReasons: [],
      availableChargeCodes: [],
      pfpPath: undefined,
      anticipatedLeave: [],
      beingImpersonated: false,
      beingImpersonatedBy: undefined,
      fullName: undefined,
      expectedBillablePercent: 0,
      startDate: undefined,
      userType: undefined,
      userLeave: [{
        type: 'PTO',
        description: 'Paid Time Off',
        annualBenefit: 0,
        startingBalance: 0,
        effectiveDate: undefined
      }],
      defaultHomePage: undefined,
      address: undefined,
      phone: undefined,
      title: undefined,
      profilePic: undefined,
      manager: undefined
    }

    this.leaveTypes = [];
    $http.get($rootScope.apiHost+"/api/leave/types", {withCredentials: true}).then(success => {
      this.leaveTypes = success.data;
    });

    // $http.get($rootScope.apiHost + '/api/admin/roles/', {withCredentials: true})
    //   .then(success => {
    //     this.roles = success.data;
    // });

    $http.get($rootScope.apiHost + '/api/admin/users/', {withCredentials: true})
      .then(success => {
        success.data.forEach(user => {
          this.allUsers.push({
            fullName: user.fullName,
            id: user.id
          });
        });
      });

      this.allChargeCodes = [];
      $http.get($rootScope.apiHost + '/api/admin/chargecodes', {withCredentials: true})
      .then(success => {
        success.data.forEach(chargeCode => {
          this.allChargeCodes.push({
            name: chargeCode.name,
            description: chargeCode.description,
            typeaheadDisplay: chargeCode.name + (chargeCode.description ? ' - ' + chargeCode.description : ''),
            id: chargeCode.id
          });
        });
      });
  }

  showStep(step) {
    this.currentStep = step;
  }

  nextStep() {
    this.currentStep++;
  }

  addManager(user) {
    this.user.manager = user.id;
  }

  onManagerBlur(event) {
    if (event.currentTarget.value === '' || event.currentTarget.value === undefined) {
      this.user.manager = undefined;
    }
  }

  toggleRole(role) {
    const index = this.user.roles.indexOf(role);
    if (index > -1) {
      this.user.roles.splice(index, 1);
    }
    else {
      this.user.roles.push(role);
    }
    this.user.roles.sort();
  }

  previousStep() {
    this.currentStep--;
  }

  getManagerName() {
    const manager = _.find(this.allUsers, u => {
      return u.id === this.user.manager;
    });
    this.managerName = manager ? manager.fullName : undefined;
    return true;
  }

  createUser() {
    let self = this;

    this.user.availableChargeCodes = this.selectedChargeCodes;

    this.$http.post(this.$rootScope.apiHost+"/api/admin/users", this.user, {withCredentials: true}).then(function (success) {
      self.state.go('admin.employee-details', {'employeeId': success.data.id});
    }, function (failure) {

    });

  }

  addChargeCode(chargeCode) {
    this.selectedChargeCodes.push(chargeCode);
    this.user.availableChargeCodes.push(chargeCode.id);
    this.selectedChargeCode = undefined;
    this.$chargecodeInput.val('');
  }

  deleteChargeCode(id) {
    // remove from the charge codes displayed in table
    let index = this.selectedChargeCodes.findIndex((chargecode) => chargecode.id === id);
    this.selectedChargeCodes.splice(index, 1);

    // remove from the available charge code indices in the user
    index = this.user.availableChargeCodes.indexOf(id);
    this.user.availableChargeCodes.splice(index, 1);
  }

  filterFn() {
    return (chargeCode) => {
      return !this.user.availableChargeCodes.includes(chargeCode.id);
    };
  }

  removeLeaveType(leaveType) {

    _.remove(this.user.userLeave, userLeave => {
      if(userLeave.type === leaveType.type) {
        return true;
      }
    });

  }

  notValid() {
    let notValid = true;

    if(!this.user.userName && this.user.userName !== ''){
      return notValid;
    }

    if(!this.user.userType) {
      return notValid;
    }

    if(!this.user.startDate) {
      return notValid;
    }

    return false;
  }

  noLeaveTypes() {
    return this.availableLeaveTypes().length === 0;
  }

  addLeaveToUser(leaveType) {
    let self = this;

    let obj = {
      type: leaveType.name,
      description: leaveType.description,
      annualBenefit: 0,
      startingBalance: 0,
      effectiveDate: undefined
    }

    this.user.userLeave.push(obj)
  }

  availableLeaveTypes() {
    let availableLeave = [];
    let self = this;
    if(self.user) {
      this.leaveTypes.forEach(function (leaveType) {
        let idx = _.findIndex(self.user.userLeave, function (l) {
          return l.type === leaveType.name;
        });

        if (idx < 0) {
          availableLeave.push(leaveType);
        }
      });
    }

    return availableLeave;
  }


}

export default EmployeeCreateController;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/employee-create.controller.js